import { render, staticRenderFns } from "./StatusDocument.vue?vue&type=template&id=75056bf8&"
import script from "./StatusDocument.vue?vue&type=script&lang=js&"
export * from "./StatusDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports